import React from "react"
import { Text } from "./text"
import { Box } from "./box"
import styled from "styled-components"

const Container = styled(Box)``

const TextAreaE = styled.textarea`
  border: 1px solid ${props => props.theme.colors.border};
  color: inherit;
  box-shadow: none;
  border-radius: ${props => props.borderRadius};
  background-color: transparent;
  padding: ${props => props.padding};
  width: 100%;
  font-size: ${props => props.fontSize};
  resize: none;
  &:focus {
    outline: none;
  }
  ${props =>
    props.hideScrollbar &&
    `
    &::-webkit-scrollbar {
      display: none !important;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  `}

  &::-webkit-scrollbar {
    width: 3px !important;
  }
  &::-webkit-scrollbar-track {
    background: #e0dcdc;
    border-radius: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.scrollbar} !important;
    border-radius: 5px;
  }
`

export const TextArea = ({
  width = "auto",
  padding = "5px 10px",
  borderRadius = "5px",
  ...props
}) => {
  return (
    <Container width={width}>
      <TextAreaE
        {...props}
        id={props.name}
        placeholder={props.placeholder}
        fontSize={props.fontSize}
        padding={padding}
        borderRadius={borderRadius}
      />
      {props.error && <Text>{props.error}</Text>}
    </Container>
  )
}

// TextArea.defaultProps = {
//   width: "auto",
//   padding: "5px 10px",
//   borderRadius: "5px",
// }
